import { Injectable } from '@angular/core';
import { changePassword } from 'src/app/shared/constants';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { UikitService } from './uikit.service';
import { environment } from 'src/environment';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordService {

  constructor(private http: HttpClient, private uikitService: UikitService,private baseService: BaseService) { }
// this service call change or reset the password
  changePasswordfun(data: any) {
    const chnagePasswordUrl = environment.apiEndpoint + environment.version + changePassword;
    return this.http.put(chnagePasswordUrl, data).pipe(
      map((response: any) => {
        if (response.status_code === 200) {
          return response;
        }
      }), catchError((error) => {
        this.baseService.disableBuuton.next(false);
        if (error?.error?.error?.code !== 1002) {
          this.uikitService.notifyError(error);
        }
        return error;
      })
    );
  }
}
